import React, { useEffect, useRef } from "react";
import Markdown from "react-markdown";
import styles from "./ChatHistory.module.css";

interface ChatMessage {
    id: string;
    user: string;
    bot: string;
}

interface ChatHistoryProps {
    messages: ChatMessage[];
}

const ChatHistory: React.FC<ChatHistoryProps> = ({ messages }) => {
    const messagesEndRef = useRef<HTMLDivElement>(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    return (
        <div
            className={styles.messageList}
            style={{ overflowY: "auto", width: "100%" }}
        >
            {messages.map((msg) => (
                <React.Fragment key={msg.id}>
                    <div className={styles.userMessage + " message"}>
                        <strong>{msg.user}</strong>
                    </div>
                    <div className={styles.botMessage + " message"}>
                        <Markdown>{msg.bot}</Markdown>
                    </div>
                </React.Fragment>
            ))}
            <div ref={messagesEndRef} />
        </div>
    );
};

export default ChatHistory;
